import React from "react";
import {
  Box,
  Typography,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Button,
  Paper
} from "@mui/material";

// アイコン
import AddIcon from '@mui/icons-material/Add';
import GroupIcon from '@mui/icons-material/Group';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

const GroupSection = ({ groups, navigate }) => {
  return (
    <Paper 
      elevation={1} 
      sx={{ 
        mb: 3, 
        borderRadius: 2, 
        overflow: 'hidden' 
      }}
    >
      <Box sx={{ 
        bgcolor: 'primary.main', 
        color: 'white', 
        px: 2, 
        py: 1.5,
        display: 'flex',
        alignItems: 'center',
        gap: 1
      }}>
        <GroupIcon />
        <Typography variant="h6" fontWeight="medium">
          グループ一覧
        </Typography>
      </Box>

      {groups.length === 0 ? (
        <Box sx={{ p: 2 }}>
          <Typography color="text.secondary" sx={{ mb: 2 }}>
            登録されているグループがありません
          </Typography>
          <Button
            variant="contained"
            color="primary"
            startIcon={<AddIcon />}
            onClick={() => navigate("/group-list")}
          >
            グループを追加
          </Button>
        </Box>
      ) : (
        <>
          <List sx={{ p: 0 }}>
            {groups.slice(0, 3).map((g) => (
              <ListItem 
                key={g.id} 
                disablePadding 
                divider
                sx={{ '&:last-child': { borderBottom: 'none' } }}
              >
                <ListItemButton onClick={() => navigate(`/group-edit/${g.id}`)}>
                  <ListItemText 
                    primary={g.name} 
                    primaryTypographyProps={{ fontWeight: 500 }}
                  />
                  <KeyboardArrowRightIcon color="action" />
                </ListItemButton>
              </ListItem>
            ))}
          </List>
          <Button
            variant="text"
            fullWidth
            endIcon={<ArrowForwardIcon />}
            onClick={() => navigate("/group-list")}
            sx={{ 
              py: 1.5, 
              borderTop: '1px solid', 
              borderColor: 'divider',
              borderRadius: 0
            }}
          >
            すべてのグループを表示
          </Button>
        </>
      )}
    </Paper>
  );
};

export default GroupSection;